module.exports = __webpack_public_path__ + "img/learn-more.86849e03.svg";